import ReactDOM from "react-dom";
import { t } from "i18next";
import OutsideClickHandler from "react-outside-click-handler";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { Link, useLocation } from "react-router-dom";
import { toFixedWithoutRounding } from "../Utils/Toast";
import ThemeContext from "../context/ThemeContext";
const ProfileModal = () => {
  const setProfileModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setProfileModal;
  });
  const setLogoutShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLogoutShow;
  });
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const refreshAmountLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.refreshAmountLoader;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const location = useLocation();
  const getImageUrl = (url) => {
    return url
  };
  return ReactDOM.createPortal(
    <div className="cdk-overlay-container">
      <div
        className="cdk-overlay-connected-position-bounding-box"
        dir="ltr"
        style={{
          opacity: "1",
          "-webkit-transform": "translate(0px, 0px)",
          "-ms-transform": "translate(0px, 0px)",
          transform: "translate(0px, 0px)",
          top: "45px",
          right: "189px",
          height: "866px",
          width: "1288px",
          "-webkit-align-items": "flex-end",
          "-webkit-box-align": "flex-end",
          "-ms-flex-align": "flex-end",
          "align-items": "flex-end",
          "-webkit-box-pack": "start",
          "-webkit-justify-content": "flex-start",
          "-ms-flex-pack": "start",
          "justify-content": "flex-start",
          "max-height": "640px",
        }}
      >
        <div
          id="cdk-overlay-1"
          className="cdk-overlay-pane"
          style={{
            width: "220px",
            height: "calc(100% - 80px)",
            position: "static",
            "-webkit-transform": "translateX(46px) translateY(15px)",
            "-ms-transform": "translateX(46px) translateY(15px)",
            transform: "translateX(46px) translateY(15px)",
          }}
        >
          <app-header-desktop-user-dropdown _nghost-serverapp-c1112501956>
            <OutsideClickHandler onOutsideClick={() => setProfileModal(false)}>
              <div
                _ngcontent-serverapp-c1112501956
                className="header-desktop-user-dropdown ng-star-inserted"
                style={{ height: "auto" }}
              >
                <div
                  _ngcontent-serverapp-c1112501956
                  className="header-desktop-user-dropdown__head"
                >
                  <div
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__user-name ng-star-inserted"
                  >
                    {profileData?.username}
                  </div>

                  <div
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__value-display value-display ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="value-display__title"
                    >
                      {t("VIPPoints")}
                    </div>
                    <div
                      _ngcontent-serverapp-c1112501956
                      className={`value-display__value value-display__value--refreshable ${
                        refreshAmountLoader
                          ? "value-display__value--reloading"
                          : ""
                      }`}
                    >
                      {" "}
                      {toFixedWithoutRounding(userCoins?.totalCoins)}
                      <div
                        onClick={() => amounutRefresh()}
                        _ngcontent-serverapp-c1112501956
                        alt="refresh"
                        className={`value-display__refresh-icon ${
                          refreshAmountLoader ? "active" : ""
                        }`}
                        style={{
                          maskImage: 'url("/assets/Other/refresh.svg")',
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  _ngcontent-serverapp-c1112501956
                  className="header-desktop-user-dropdown__group ng-star-inserted"
                >
                  <Link
                    to="/wallet/deposit"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/NewIcon/icon-deposit.png",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("Deposit")}
                    </div>
                  </Link>

                  <Link
                    to="/wallet/withdraw"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/NewIcon/icon-withdrawal.png",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("Withdrawal")}
                    </div>
                  </Link>
                </div>
                <div
                  _ngcontent-serverapp-c1112501956
                  className="header-desktop-user-dropdown__group ng-star-inserted"
                >
                  <Link
                    to="/betting-history"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/NewIcon/icon-bet-records.png",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("BettingRecords")}
                    </div>
                  </Link>

                  <Link
                    to="/account-statement"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/NewIcon/icon-turnover.png",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                     Account Statement
                    </div>
                  </Link>

                  <Link
                    to="/transaction-records"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/NewIcon/icon-records.png",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("TransactionRecords")}
                    </div>
                  </Link>
                </div>
                <div
                  _ngcontent-serverapp-c1112501956
                  className="header-desktop-user-dropdown__group ng-star-inserted"
                >
                  <Link
                    to="/profile"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/NewIcon/icon-profile.png",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("PersonalInfo")}
                    </div>
                  </Link>

                  {/* <Link
                    to="/affiliate-link"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/Icon/icon-vip.svg",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("AffiliateLink")}
                    </div>
                  </Link> */}

                  <Link
                    to="/reset-password"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/NewIcon/icon-changepassword.png",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("ResetPassword")}
                    </div>
                  </Link>

                  {/* <a
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image":
                          'url("https://img.e491328.com/e28/h5/assets/images/light/menu/icon-inbox.svg?v=1762247150189")',
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      Inbox
                    </div>
                    <span
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__notice ng-star-inserted"
                    >
                      1
                    </span>
                  </a> */}

                  <Link
                    to="/refrel"
                    state={{ background: location }}
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon ng-star-inserted"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/NewIcon/icon-referral.png",
                        )})`,
                      }}
                    />

                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("Referral")}
                    </div>
                  </Link>
                </div>

                <div
                  onClick={() => setLogoutShow(true)}
                  _ngcontent-serverapp-c1112501956
                  className="header-desktop-user-dropdown__group"
                >
                  <a
                    _ngcontent-serverapp-c1112501956
                    className="header-desktop-user-dropdown__item header-desktop-user-dropdown-item"
                  >
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__icon"
                      style={{
                        backgroundImage: `url(${getImageUrl(
                          "/assets/NewIcon/icon-logout.png",
                        )})`,
                      }}
                    />
                    <div
                      _ngcontent-serverapp-c1112501956
                      className="header-desktop-user-dropdown-item__text"
                    >
                      {t("Logout")}
                    </div>
                  </a>
                </div>
              </div>{" "}
            </OutsideClickHandler>
          </app-header-desktop-user-dropdown>
        </div>
      </div>
    </div>,
    document.getElementById("overlay"),
  );
};

export default ProfileModal;
